import { Component, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment-jalaali';
import { CookieService } from 'ngx-cookie-service';
import { Observable, Subscription, of } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, switchMap, tap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { VERSION } from '../../../version';
import { AuthService } from '../../providers/auth.service';
import { UserService } from '../../providers/user.service';
import { AccountLegalFormComponent } from '../../views/general/account-legal-form/account-legal-form.component';
import { AccountNaturalFormComponent } from '../../views/general/account-natural-form/account-natural-form.component';
import { IssueFormComponent } from '../../views/home/issue-form/issue-form.component';
import { BasketComponent } from '../../views/sales/basket/basket.component';
import { BaseComponent } from '../../views/shared/base/base.component';
import { FormComponent } from '../../views/shared/form/form.component';
import { SmsAccountListComponent } from '../../views/shared/sms-account-list/sms-account-list.component';
import { TransactionAccountListComponent } from '../../views/finance/transaction-account-list/transaction-account-list.component';

@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html',
  styleUrls: ['./default-layout.component.scss']
})
export class DefaultLayoutComponent extends BaseComponent implements OnInit, OnDestroy {
  // The layout is torn down and rebuilt on every logout/login cycle in the same
  // tab, so the socket listener and the call listener have to be released with it
  // -- otherwise each cycle leaves another copy running and one incoming call
  // raises a toast (and creates a sales.call issue) once per stale copy.
  private messageSubscription: Subscription;
  private stopCalls: () => void;

  constructor(
    public cookieService: CookieService,
    public activeModal: NgbModal,
    public titleService: Title,
    public translator: TranslateService,
    public userService: UserService,
    public authService: AuthService,
    public router: Router
  ) {
    super(userService, translator, cookieService, titleService);
    this.messageSubscription = this.userService.getMessage().subscribe(msg => {
      console.log(msg);
      this.handleInfo(msg);
    })
    // setInterval(() => {
    //   this.userService.sendMessage('Hello from web');
    // }, 1000)
    // api/version now returns the API's own version as plain text, not
    // { web, app }; comparing it with VERSION (this app's package.json) only
    // tells whether the API was deployed after this build, not the web.
    // userService.getVersion().subscribe(
    //   (version: string) => {
    //     if (version > VERSION) {
    //       setTimeout(() => {
    //         if (window.confirm(this.translator.instant('NEW_VERSION'))) {
    //           window.location.reload();
    //         }
    //       }, 5000);
    //       // this.handleError();
    //     }
    //   }, error => {
    //     console.error(error);
    //   }
    // );

    // if (this.token) {
    //   this.authService.reauthenticate().subscribe((res) => {
    //     if (res.ok !== true || res.status !== 200 || res['_body'] === 'Unauthorized') {
    //       this.router.navigate(['/login']);
    //     }
    //   }, (err) => {
    //     this.logOut();
    //   });
    // } else {
    //   this.logOut();
    // }
    // this.subscription = invoiceService.invoiceChange.subscribe(
    //   result => {
    //     setTimeout(() => {
    //       this.loadBasket();
    //     }, 1000);
    //   });

    // this.changes = new MutationObserver((mutations) => {
    //   this.sidebarMinimized = document.body.classList.contains('sidebar-minimized');
    // });

    // this.changes.observe(<Element>this.element, {
    //   attributes: true
    // });

    // window.onbeforeunload = async (e) => {
    //   if (this.selectedAccount) {
    //     e.returnValue = false;
    //     await this.unselectUser();
    //   }
    // };

  }
  version = VERSION;
  currentYear = moment().year();
  public sidebarMinimized = true;
  // private changes: MutationObserver;
  // public element: HTMLElement = document.body;
  // messages = [];
  // unreadMsg = 0;
  // invoicesLength: number;
  users: any;
  userNavItem: any = [];
  navItems: any = [];
  screensize = window.screen;
  searching = false;
  searchFailed = false;

  account: any;
  legals: any = [];
  searchMode = 'account';
  targetUser: any;
  access = {
    customSubject: false,
    deleteWorklog: false,
    userSelector: false,
    editAccount: false,
    autoSelector: false
  };

  async ngOnInit() {
    await super.ngOnInit();
    try {
      if (this.token) {
        const reauth = await this.authService.reauthenticate().toPromise();
        this.authService.sendMessage(this.token);
        if (!this.selectedAccount) {
          this.account = reauth[0];
          this.legals = await this.userService.getLegals(this.username).toPromise();
        } else {
          this.account = (await this.userService.getAccount(this.selectedAccount || this.username).toPromise())[0];
        }



        const menuStr = sessionStorage.getItem('menus');
        if (!this.selectedAccount && menuStr) {
          this.navItems = JSON.parse(menuStr);
        } else {
          const menu = await this.userService.menu(this.selectedAccount).toPromise();
          this.navItems = menu;
          sessionStorage.setItem('menus', JSON.stringify(this.navItems));
        }
        this.authService.done.emit('menus');
        this.loadPrivileges();
        if (this.internalLine && !this.selectedAccount) {
          if (environment.production) {
            this.listenForCalls();
          }

        }
        if (this.role.includes('PERSONNEL') && navigator.geolocation && !this.selectedAccount) {
          try {
            navigator.geolocation.watchPosition(async (position) => {
              if (this.latitude != position.coords.latitude && this.longitude != position.coords.longitude) {
                this.latitude = position.coords.latitude;
                this.longitude = position.coords.longitude;
                // if (this.latitude && this.longitude) {
                //   await this.authService.sendLocation(this.latitude, this.longitude).toPromise()
                // }
              }

            }, (error) => {
            }, { enableHighAccuracy: true });
          } catch (error) {
            console.error(error);
          }
          // setInterval(async () => {
          //   try {
          //     this.cookLocation();
          //     if (this.latitude && this.longitude) {
          //       await this.authService.sendLocation(this.latitude, this.longitude).toPromise()
          //     }
          //   } catch (error) {
          //     console.error(error);
          //   }
          // }, 60000)
        }
      } else {
        throw new Error(this.translator.instant('TOKEN_NO_FOUND'));
      }
    } catch (error) {
      console.log(error);
      this.logOut();
    }
  }

  private loadPrivileges() {
    this.access.customSubject = this.roles.filter(r => [
      'CUSTOMER_CARE_SUP', 'SALES_SUP', 'CR_SUP', 'FINANCE_SUP', 'NOC_SUP'].includes(r)).length > 0;
    this.access.deleteWorklog = this.roles.filter(r => [
      'CUSTOMER_CARE_MNG', 'SALES_MNG', 'NOC_MNG', 'FINANCE_MNG'].includes(r)).length > 0;
    this.access.userSelector = this.roles.filter(r => [
      'PERSONNEL', 'RESELLER'].includes(r)).length > 0;
    this.access.editAccount = this.roles.filter(r => [
      'SALES_OFC', 'SALES_OFS', 'CONTRACT_OFC', 'FINANCE_OFC', 'CUSTOMER_CARE_OFC', 'INSTALLER', 'INSTALL_OFC', 'INP_MARKETER'].includes(r)).length > 0;
    // this.access.autoSelector = this.internalLine !== null && this.internalLine !== undefined;
    // && this.roles.filter(r => [
    //   'CUSTOMER_CARE_OFC', 'CUSTOMER_CARE_SUP', 'SALES_OFC', 'DEDICATE_SALES_OFC', 'CR_OFC', 'FINANCE_OFC', 'NOC_SUP'
    // ].includes(r)).length > 0;
  }

  // private loadMessages() {
  //   this.accountService.getMessages(this.selectedAccount || this.username).subscribe((result: any) => {
  //     if (result.ok) {
  //       this.messages = result.json().reverse();
  //       this.unreadMsg = this.messages.filter(m => !m.is_read).length;
  //     }
  //   });
  // }

  // private loadBasket() {
  //   this.invoiceService.getPendingInvoices(this.account.username).subscribe((result: any) => {
  //     if (result.ok) {
  //       this.invoicesLength = result.json().length;
  //     }
  //   });
  // }

  private logOut() {
    // clearCookie() clears sessionStorage too.
    this.clearCookie();
    this.router.navigate(['/login']);
  }

  openModal(content, modalSize?) {
    return this.activeModal.open(content, { size: modalSize || 'lg' });
  }

  formatter = (result: string) => result.toUpperCase();
  inputFormatter = (x: { username: string }) => x.username ? x.username : x;

  search = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      tap(() => this.searching = true),
      switchMap(term =>
        this.userService.readTypeahead(term, this.searchMode).pipe(
          tap((result) => {
            this.searchFailed = false;
          }),
          catchError(() => {
            this.searchFailed = true;
            return of([]);
          }))
      ),
      tap(() => this.searching = false)
    )

  typeaheadClicked(event) {
    if (this.targetUser.username) {
      this.select(this.targetUser);
    }
  }

  select(row) {
    // const oldSelectedAccount = sessionStorage.getItem('selectedAccount');
    // const oldSelectedUser = sessionStorage.getItem('selectedUser');
    // const oldWorklogId = sessionStorage.getItem('workLogId');
    // const oldUsers = sessionStorage.getItem('users');

    const account_id = this.searchMode === 'user' ? row.account_id : row.username;
    const user_id = this.searchMode === 'user' ? row.username : undefined;
    const sip_id = row.sip_id;
    this.userService.apiCall('api/work_log/create', { account_id, user_id, sip_id }).subscribe((result: any) => {
      let w = window.open('/', account_id);
      if (w) {
        // PostgreSQL does not return MySQL's `insertId`; /:entity/create answers
        // with the pg result object, so the new row's key is rows[0].id. Reading
        // .insertId yielded undefined, and sessionStorage.setItem stringifies --
        // storing the literal text "undefined", which is truthy, so deleteLog()
        // skipped its fallback lookup and posted { id: "undefined" } to the API.
        const newWorkLogId = result?.rows?.[0]?.id;
        if (newWorkLogId) {
          w.sessionStorage.setItem('workLogId', String(newWorkLogId));
        }
        w.sessionStorage.setItem('selectedAccount', account_id);
        if (user_id) {
          w.sessionStorage.setItem('selectedUser', user_id);
        }
      }
      this.targetUser = null;

      // if (oldSelectedAccount) {
      //   sessionStorage.setItem('selectedAccount', oldSelectedAccount);
      // } else {
      //   sessionStorage.removeItem('selectedAccount');
      // }

      // if (oldSelectedUser) {
      //   sessionStorage.setItem('selectedUser', oldSelectedUser);
      // } else {
      //   sessionStorage.removeItem('selectedUser');
      // }

      // if (oldWorklogId) {
      //   sessionStorage.setItem('workLogId', oldWorklogId);
      // } else {
      //   sessionStorage.removeItem('workLogId');
      // }

      // if (oldUsers) {
      //   sessionStorage.setItem('users', oldUsers);
      // } else {
      //   sessionStorage.removeItem('users');
      // }
    }, error => {
      console.log(error)
      let w = window.open('/', account_id);
      if (w) {
        w.sessionStorage.setItem('selectedAccount', account_id);
        if (user_id) {
          w.sessionStorage.setItem('selectedUser', user_id);
        }
      }
      this.targetUser = null;
    });
  }

  async unselectUser() {
    // sessionStorage only holds strings, so a session that stored an undefined id
    // before the insertId fix above has the literal text "undefined" in it -- which
    // is truthy and would skip the lookup below. Treat it as absent so those
    // sessions recover on their own instead of posting it to the API.
    let workLogId = sessionStorage.getItem('workLogId');
    if (workLogId === 'undefined' || workLogId === 'null') {
      sessionStorage.removeItem('workLogId');
      workLogId = null;
    }
    if (!workLogId) {
      let workLogs = await this.userService.apiCall('api/work_log/read', {
        fields: ['id'],
        query: [['account_id', '=', this.selectedAccount], 'and', ['created_by', '=', this.username]],
        desc: true,
        limit: 1,
        raw: true
      }).toPromise();
      if (workLogs[0]) {
        workLogId = workLogs[0].id;
      }
    }

    if (workLogId) {
      const form = this.openModal(FormComponent);
      form.componentInstance.entityName = 'work_log';
      form.componentInstance.custom = async (field) => {
        if (field.name === 'subject') {
          field.type.edit = this.access.customSubject;
        }
        return field;
      };
      form.componentInstance.id = workLogId;
      form.componentInstance.formData['user_id'] = this.selectedUser;
      form.componentInstance.isEdit = true;
      form.componentInstance.done.subscribe(worklog => {
        if (worklog) {
          if (!worklog.is_solved) {
            const issueForm = this.activeModal.open(IssueFormComponent, { size: 'lg' });
            issueForm.componentInstance.params = {
              defaultDepartment: 'technical',
              defaultType: 'support',
              entity: 'USER',
              ref: worklog.user_id,
              description: worklog.description
            };
            issueForm.result.then(issue => {
              if (issue) {
                this.dismiss();
              }
            });
          } else {
            this.dismiss();
          }
        }
      }, error => {
        this.handleError(error);
      });
    } else {
      console.error('Worklog id not found');
      this.dismiss();
    }
  }

  dismiss() {
    // sessionStorage.removeItem('selectedAccount');
    // sessionStorage.removeItem('selectedUser');
    // sessionStorage.removeItem('workLogId');
    window.close();
  }

  async deleteLog() {
    // sessionStorage only holds strings, so a session that stored an undefined id
    // before the insertId fix above has the literal text "undefined" in it -- which
    // is truthy and would skip the lookup below. Treat it as absent so those
    // sessions recover on their own instead of posting it to the API.
    let workLogId = sessionStorage.getItem('workLogId');
    if (workLogId === 'undefined' || workLogId === 'null') {
      sessionStorage.removeItem('workLogId');
      workLogId = null;
    }
    if (!workLogId) {
      let workLogs = await this.userService.apiCall('api/work_log/read', {
        fields: ['id'],
        query: [['account_id', '=', this.selectedAccount], 'and', ['created_by', '=', this.username]],
        desc: true,
        limit: 1,
        raw: true
      }).toPromise();
      if (workLogs[0]) {
        workLogId = workLogs[0].id;
      }
    }
    if (workLogId) {
      await this.userService.apiCall('api/work_log/delete', { id: workLogId }).toPromise();
    }
    this.dismiss();
  }

  createIssue() {
    this.openModal(IssueFormComponent);
  }

  openBasket() {
    this.openModal(BasketComponent, 'xl');
  }

  openMessages() {
    this.openModal(SmsAccountListComponent);
  }

  openProfile() {
    const form = this.openModal(this.account.person_type === 'N' ? AccountNaturalFormComponent : AccountLegalFormComponent);
    form.componentInstance.id = this.account.username;
    form.componentInstance.isEdit = true;
  }

  openAgentProfile() {
    if (this.account && this.account.agent_id) {
      this.select({ username: this.account.agent_id });
    }
  }

  openStatement() {
    this.openModal(TransactionAccountListComponent);
  }

  async recalcBalance() {
    try {
      await this.service.perform('account', 'recalc_balance', { username: this.account.username }).toPromise();
      this.handleSuccess();
    } catch (error) {
      this.handleError(error);
    }
  }

  changePass() {
    const changePasswordForm = this.activeModal.open(FormComponent, { size: 'sm' });
    changePasswordForm.componentInstance.colCount = 1;
    changePasswordForm.componentInstance.title = this.translator.instant('CHANGE_PASSWORD');
    changePasswordForm.componentInstance.hiddenApply = true;
    changePasswordForm.componentInstance.hiddenReset = true;
    changePasswordForm.componentInstance.fields = [
      {
        name: 'password',
        caption: this.translator.instant('NEW_PASSWORD'),
        type: {
          name: 'text',
          mode: 'password',
        },
        rules: [{ type: 'required' }]
      },
      {
        name: 'confirm',
        caption: this.translator.instant('REPEAT_NEW_PASSWORD'),
        type: {
          name: 'text',
          mode: 'password',
        },
        rules: [{ type: 'required' }]
      },
    ];

    changePasswordForm.componentInstance.done.subscribe((res) => {
      if (res.password === res.confirm) {
        changePasswordForm.componentInstance.loading = true;
        this.authService.changePassword(res.password).subscribe(res2 => {
          changePasswordForm.componentInstance.loading = false;
          this.handleSuccess();
          changePasswordForm.close();
        }, error => {
          this.handleError(error);
          changePasswordForm.componentInstance.loading = false;
        })
      } else {
        changePasswordForm.componentInstance.loading = false;
        this.handleError(this.translator.instant('MSG_CHANGE_PASSWORD_NEW_NOT_EQ_CONFIRM'));
      }
    });

    // this.userService.setChangePassword().subscribe(
    //   (result: any) => {
    //     this.logOut();
    //   }, error => {
    //     this.handleError(error);
    //   }
    // );
  }

  resetPassword() {
    this.authService.resetPassword(this.selectedAccount).subscribe((result: any) => {
      this.handleSuccess();
    }, error => {
      this.handleError(error);
    });
  }

  async call(account, type) {
    try {
      await this.service.perform('account', `call_${type}`, { username: account }).toPromise();
    } catch (error) {
      this.handleError(error);
    }
  }

  ngOnDestroy() {
    if (this.messageSubscription) {
      this.messageSubscription.unsubscribe();
      this.messageSubscription = undefined;
    }
    if (this.stopCalls) {
      this.stopCalls();
      this.stopCalls = undefined;
    }
  }

  /**
   * Incoming calls for this tab's internal line.
   *
   * Staff keep several tabs open and every one of them is in the line's socket
   * room, so a broadcast used to make each tab select the caller or create its
   * own sales.call issue (and the 10 s poller that replaced it raced the same
   * way). The API now broadcasts only { uid, target }: the tab the user focused
   * last (`call:active`) claims at once, the rest claim after 3 s in case that
   * tab is gone, and the API hands the call to exactly one claim.
   */
  private listenForCalls() {
    const socket = this.userService.socket;
    const reportActive = () => {
      if (document.visibilityState === 'visible' && document.hasFocus()) {
        socket.emit('call:active');
      }
    };
    // A reconnect is a new socket id on the API; report again once re-authenticated.
    const onConnect = () => this.userService.authenticate().then(reportActive).catch(() => undefined);

    window.addEventListener('focus', reportActive);
    document.addEventListener('visibilitychange', reportActive);
    socket.on('connect', onConnect);
    onConnect();

    const ring = socket.fromEvent('call').subscribe((call: any) => {
      if (!call || !call.uid) { return; }
      const mine = call.target && call.target === socket.ioSocket.id;
      setTimeout(() => socket.emit('call:claim', { uid: call.uid }, (ack: any) => {
        if (ack && ack.data) {
          this.handleCall(ack.data).catch(error => console.error(error));
        }
      }), mine ? 0 : 3000);
    });

    this.stopCalls = () => {
      ring.unsubscribe();
      window.removeEventListener('focus', reportActive);
      document.removeEventListener('visibilitychange', reportActive);
      socket.removeListener('connect', onConnect);
    };
  }

  private async handleCall(call: any) {
    if (call) {
      if (call['username']) {
        this.searchMode = 'account';
        this.select(call);
      }
      else if (this.ownRole.includes('SALES_OFC') || this.ownRole.includes('SALES_OFS') || this.ownRole.includes('SALES_SUP') || this.ownRole.includes('SALES_OFS') || this.ownRole.includes('DEDICATE_SALES_OFC')) {
        const num = call['ext'];
        await this.userService.apiCall('api/issue/create',
          {
            department: 'sales',
            type: 'sales.call',
            severity: 3,
            call_type: 'ورودی',
            sip_id: call['uid'],
            tel: num.length == 10 && num.startsWith('9') ? undefined : `0${num.length == 8 ? '21' : ''}${num}`,
            mobile: num.length == 10 && num.startsWith('9') ? `0${num}` : undefined
          }
        ).toPromise();
        /*
        const issueForm = this.activeModal.open(IssueFormComponent, { size: 'lg' });
        issueForm.componentInstance.params = {
          department: 'sales',
          type: 'call',
          data: {
            call_type: 'ورودی',
            tel: num.length == 10 && num.startsWith('9') ? undefined : `0${num.length == 8 ? '21' : ''}${num}`,
            mobile: num.length == 10 && num.startsWith('9') ? `0${num}` : undefined
          }
        };
        */
      }
    }
  }

}
